import React, { useEffect, useState } from "react";
import PopupModal from "../../../Components/ModalComponent/PopupModal";

import { ManageApis } from "../../../AppServices/ManageApi";
import TableComponent from "../../../Components/TableComponent/TableComponent";
import { useNavigate } from "react-router-dom";
import AlertBox from "../../../Components/AlertBox/AlertBox";
import Loader from "../../../Components/LoaderComponent/Loader";
import InputComponent2 from "../../../Components/InputComponent/InputComponent2";
import nodata from "../../../assets/images/no-data.png";
import { MultiSelect } from "react-multi-select-component";
import {
  PreventNonNumeric,
  dataTableInitialLoader,
  emailValidation,
  formateString,
  formatingValue,
  handleCopy,
  limitCharacters,
  preventSpecialChars,
  userValidation,
} from "../../../Functions/Utils";
import DataTable from "../../../Components/DataTable/DataTable";
import { Input, Message, Select } from "@arco-design/web-react";
const InputSearch = Input.Search;

function ClientAdminList() {
  let userCreateinitialValue = {
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    assignedMenus: "",
    assignedServices: [],
    clientId: "",
    password: "",
  };
  const AlertinitialValue = {
    show: false,
    message: "",
    isfalse: false,
    isSuccess: false,
  };
  const [visible, setVisible] = useState({
    show: false,
    type: "",
  });
  const customStyles = {
    option: 'custom-option', // custom class for options
  };
  const [searchText, setSearchText] = useState("");
  const [showAlert, setShowAlert] = useState(AlertinitialValue);
  const [UserList, setUserList] = useState([]);
  const [userAccountListData, setUserAccountListData] = useState([]);
  const [getAllAccount, setGetAllAccount] = useState([]);
  const [data, setData] = useState([]);
  const [tableLoader, setTableLoader] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [pageSize, setpageSize] = useState(10);
  const [createUserData, setCreateUserData] = useState(userCreateinitialValue);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [selected, setSelected] = useState([]);
  const [selectedmenu, setSelectedmenu] = useState([]);
  const [selectedservice, setSelectedservice] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState([]);
  const [option, setOption] = useState([]);
  const [serviceOption, setServiceOption] = useState([]);
  const [menuOption, setMenuOption] = useState([]);
  const [newAccount, setNewAccount] = useState([]);
  const [currentUserId, setCurrentUserId] = useState()
  const navigate = useNavigate();
  useEffect(() => {
    ServiceListData()
    MenuListData()
    getUserList();
    listAcountId();
    localStorage.removeItem("storedLockenabled");
  }, []);
  // useEffect(() => {
  //   // //console.log("---------->", createUserData)
  // }, [createUserData]);

  let newUserCreateForm = [
    {
      type: "text",
      name: "firstName",
      label: "First Name",
      regex: formatingValue,
      required:true,
    },
    {
      type: "text",
      name: "lastName",
      label: "Last Name",
      regex: formatingValue,
      required:true,
    },
    { type: "text", name: "email", label: "Email", regex: emailValidation(),required:true, },
    {
      type: "multiselect",
      name: "assignedServices",
      label: "Services",
      options:serviceOption,
      selected : selectedservice,
      required:false,
    //   regex: limitCharacters,
    },
    {
      type: "multiselect",
      name: "assignedMenus",
      label: "Menu",
      options:menuOption,
      selected : selectedmenu,
      required:true,
    //   regex: limitCharacters,
    },
    {
      type: "select",
      name: "clientId",
      label: "Account Type",
      options:option,
      regex: limitCharacters,
      required:true,
    },
    {
      type: "text",
      name: "username",
      label: "User Name",
      regex: limitCharacters,
      required:true,
    },
    // { type: "select", name: "accountsId", label: "Account Type", regex: "" },
    { type: "password", name: "password", label: "Password", regex: "", required:true, },
  ];

//   const options = [
//     { label: "Grapes 🍇", value: "grapes" },
//     { label: "Mango 🥭", value: "mango" },
//     { label: "Strawberry 🍓", value: "strawberry" },
//   ];

  const accountsColumn = [
    {
      title: "Account Name",
      dataIndex: "clientName",
    },
    {
      title: "Status",
      dataIndex: "status",
    }, {
      title: "Account Id",
      dataIndex: "",
      width: "200px",
      render: (text, record) => (
        // //console.log(record),

     
        <button
          className="btn btn-master w-75 px-2 font_13 py-1 text-nowrap"
          onClick={() => handleCopy(record?.clientId)}
        >
          Copy Account Id
        </button>
      ),
    },
    {
      title: "Action",
      width: "230px",
      render: (v, record) => {
        return (
          // //console.log("sssssssssssssss", record),
          <>
            <div className="row">
              <div className="col-12 col-md-6 p-0 pe-md-2">
                <button
                  className="btn btn-master w-100 px-2 font_13 py-1 mb-1 text-nowrap"
                  onClick={() => handleActivateDeactivateAccount(record)}
                >
                  {record?.status == "Active" ? "Deactivate" : "Activate"}
                </button>
              </div >
              <div className="col-12 col-md-6 p-0">
                <button
                  className="btn btn-master px-2 w-100 font_13 py-1 text-nowrap"
                  onClick={() => handleRemoveRecord(record)}
                >
                  Remove
                </button>
              </div>
            </div >
          </>
        );
      },
    },
  ];

  const columns = [
    {
      title: "Name",
      dataIndex: "fullName",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Accounts",
      dataIndex: "createdDate",
      render: (text, record) => (
        // //console.log(record),

        <i
          className="far fa-eye  icn p-2 text_master"
          onClick={() => handleListAccount(record.id)}
        ></i>
      ),
    },
    {
    title: "User Id",
      dataIndex: "",
      width: "200px",
      render: (text, record) => (
      <>
      
      
      <button
      className="sm-d-none btn btn-master px-2 w-100 font_13 py-1 md-d-block text-nowrap"
      onClick={() =>  handleCopy(record?.id)}
    >
      Copy UserId
          </button>
         
      </>
       
    ),
   
},
    {
      title: "Action",
      width: "200px",
      render: (v, record) => {
        return (
          // //console.log("sssssssssssssss", record),
          <>
       
           <button
           className="btn btn-master px-2 w-100 font_13 py-1 text-nowrap"
           onClick={() => onclickView(record)}
         >
           View
            </button>
            </>
        );
      },
    },
  ];

  const getUserList = async () => {
    try {
      setIsLoading(true);
      let response = await ManageApis("get", global.GetAdminClientListing);
      console.log(response);
      if (response.message === "Success") {
        // ""
        setIsLoading(false);
        setData((prev) =>
          response?.response_data?.map(
            ({ id, firstName, lastName, email, lockoutEnabled }) => ({
              id,
              fullName: `${firstName} ${lastName}`,
              email,
              lockoutEnabled,
            })
          )
        );
        setUserList((prev) =>
          response?.response_data?.map(
            ({ id, firstName, lastName, email, lockoutEnabled }) => ({
              id,
              fullName: `${firstName} ${lastName}`,
              email,
              lockoutEnabled,
            })
          )
        );
      } else {
        // //console.log(response);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
    }
  };
  const onclickView = (param) => {
    // ""
    //handle on click view btn in table

    navigate("/admin/user-details", { state: { userData: param } });
  };

  const handleChange = (e, regex) => {
    const { name, value } = e.target;
    switch (name) {
      case "email":
      case "password":
      case "username":
        setCreateUserData((prevData) => ({ ...prevData, [name]: value }));
        handleError(null, name);
        break;
      case "clientId": // Adjusted to match the name attribute of select
        setCreateUserData((prevData) => ({ ...prevData, [name]: value }));
        handleError(null, name);
        break;
      default:
        setCreateUserData((prevData) => ({
          ...prevData,
          [name]: regex(value, 100, /[^a-zA-Z \s]/g),
        }));
        handleError(null, name);
        break;
    }
  };
  

  const handleError = (error, input) => {
    // ""
    setErrors((prevState) => ({ ...prevState, [input]: error }));
  };
  const validate = () => {
    let isValid = true;
    const requiredFields = ["firstName", "lastName", "email", "assignedMenus", "clientId", "username", "password"];
  
    requiredFields.forEach((field) => {
      if (!createUserData[field]) {
        handleError(`Please fill ${field.replace("_", " ")}`, field);
        isValid = false;
      }
    });
  
    if (!emailValidation(createUserData.email)) {
      handleError("Please enter a valid email address", "email");
      isValid = false;
    }
  
    return isValid;
  };
  


  // useEffect(() => {
  //   // ""
  //   //console.log("Validation Errors ===>", errors)
  // }, [errors])
  const handleCreateUserSubmit = async () => {
    try {
      if (validate()) {
        setIsLoading(true);
  
        // Prepare account list for submission
        // const accountList = selected.map((itm) => ({ clientid: itm.value }));
        // setCreateUserData((prevData) => ({
        //   ...prevData,
        //   mappingUserClientRequest: accountList,
        // }));
  
        const reqstBody = createUserData;
  
        // Make API call to create user
        let response = await ManageApis("post", global.CreateAdminClient, reqstBody);
  
        if (response.message === "Success") {
          setVisible(false)
          setSelectedservice("");
        setSelectedmenu("");
          setShowAlert({
            show: true,
            message: "User Created Successfully",
            isSuccess: true,
          });
  
          // Optionally update user list or perform other actions on success
          // setUserList(prevList => [
          //   {
          //     id: response?.response_data?.userId,
          //     fullName: `${createUserData.firstName} ${createUserData.lastName}`,
          //     email: createUserData.email,
          //   },
          //   ...prevList,
          // ]);
  
          setCreateUserData(userCreateinitialValue);
          setSelected([]);
        } else {
          
          setSelectedservice("");
          setSelectedmenu("");
          setVisible(false)
          setShowAlert({
            show: true,
            message: response?.response_data?.message || "Something went wrong!",
            isfalse: true,
          });
        }
      } else {
        // Form validation failed
        // Handle invalid form state if needed
      }
    } catch (error) {
      // Handle API call errors or other unexpected errors
      setShowAlert({
        show: true,
        message: "Something went wrong!",
        isfalse: true,
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleAlertBoxCancel = () => {
    if (showAlert.isSuccess) {
      getUserList();
      setShowAlert(AlertinitialValue);
    } else {
      setShowAlert(AlertinitialValue);
    }
  };

  const handleMultiselect = (e, type) => {
    // ""\
    switch (type) {
        case "assignedServices":
          setSelectedservice(e);
            setErrors({})
      
            const accountList = e.map((itm) => itm.value);
      
            setCreateUserData((prv) => ({
              ...prv,
              ["assignedServices"]: accountList,
            }));
            break;
    case "assignedMenus":
    setSelectedmenu(e);
    setErrors({})

    const menulist = e.map((itm) => itm.value);

    setCreateUserData((prv) => ({
      ...prv,
      ["assignedMenus"]: menulist,
    }));
    break;
        default:
            const accountList2 = e.map((itm) => ({ clientid: itm.value }));

            setSelectedAccount(e);
            setNewAccount((prv) => ({
              ...prv,
              ["accountList"]: accountList2,
            }));
            break;
    }
    if (type == "newClient") {
     
    }
    else {
    

    }
  };

  function onChangeTable(pagination) {
    // //console.log(pagination);
    const { current, pageSize } = pagination;
    setTableLoader(true);
    setUserList(dataTableInitialLoader(columns));

    setTimeout(() => {
      setUserList(data.slice((current - 1) * pageSize, current * pageSize));
      setcurrentPage(current);
      setpageSize(pageSize);
      setTableLoader(false);
    }, 2000);
  }

  const listAcountId = async () => {
    try {
      let result = await ManageApis("get", global.getClientsList);
      if (result.message === "Success") {
        setOption(
          result.response_data.map((itm) => ({
            label: itm.name,
            value: itm.id, // Ensure value is set to the ID
            key: itm.id,
          }))
        );
        setGetAllAccount(result.response_data);
      } else {
        // Handle error or other cases
      }
    } catch (error) {
      // Handle error
    }
  };
  

  const ServiceListData = async () =>{
  
    try {
        let serviceresult = await ManageApis("get", global.ServiceDropDownValueList);
        if (serviceresult.message == "Success") {
            setServiceOption(
                serviceresult.response_data.map((itm) => ({
                label: itm.name,
                value: itm.id,
                key: itm.id,
              }))
            );
            setGetAllAccount(serviceresult.response_data);
          } else {
            // //console.log(result);
          }
    } catch (error) {
        
    }
  }

  const MenuListData = async () =>{
    try {
        let menuresult = await ManageApis("get", global.MenuDropDownList);
        if (menuresult.message == "Success") {
            setMenuOption(
                menuresult.response_data.map((itm) => ({
                label: itm.name,
                value: itm.id,
                key: itm.id,
              }))
            );
            setGetAllAccount(menuresult.response_data);
          } else {
            // //console.log(result);
          }
    } catch (error) {
        
    }
  }

  const handlesearch = (value) => {
    setSearchText(formatingValue(value, 20, /[^a-zA-Z\s]/g));
    try {
      if (searchText) {
        setUserList(() =>
          data.filter((itm) =>
            itm?.fullName?.toLowerCase().includes(value?.toLowerCase())
          )
        );
      } else {
        setUserList(data);
      }
    } catch (error) {
      // console.error("An error occurred:", error.message);
    }
  };

  const handleListAccount = async (id) => {
    setNewAccount()
    setSelectedAccount([])
    setCurrentUserId(id)
    try {
      // ""
      setIsLoading(true);
      let param = `?UserId=${id}`;
      let result = await ManageApis("get", global.GetAccountName, param);
      if (result.message === "Success") {
        //console.log(result?.response_data);
        // "";

        let formatedData = result?.response_data?.map((itm) => ({
          ...itm,
          userId: id,
        }));
        setUserAccountListData(formatedData);
        setIsLoading(false);

        setVisible(() => ({ type: "list_account", show: true }));
      } else {
        setIsLoading(false);
        setShowAlert((pre) => ({
          ...pre,
          show: true,
          message: "Something went wrong...!",
          isfalse: true,
        }));
      }
    } catch (error) {
      setIsLoading(false);
      // //console.log(error)
    }
  };

  // handle removeclient by user
  const handleRemoveRecord = async (data) => {
    try {

      //console.log("dd", data);
      let param = `?userId=${data?.userId}&clientId=${data?.clientId}`;
      setIsLoading(true)
      setVisible((pre) => ({ show: false, type: "" }));
      let result = await ManageApis(
        "post",
        global.RemoveClientByUser + param
      );
      if (result?.message == "Success") {

        Message.success("Delete Account Successfully");
        setIsLoading(false);
      } else {
        setIsLoading(false);

        Message.error(
          result?.message || "Something went wrong! Please try again later."
        );
      }


    } catch (error) {
      setIsLoading(false)
      //console.log(error)
    }


  };

  const handleActivateDeactivateAccount = async (data) => {
    try {
      //console.log(data);
      let param = `?userId=${data?.userId}&clientId=${data?.clientId}`;
      //  ? 'Deactivate' : 'Activate'
      if (data?.status == "Active") {
        setIsLoading(true);
        setVisible((pre) => ({ show: false, type: "" }));
        // try to deactivate on active case
        let result = await ManageApis(
          "post",
          global.DeactivateClientByUser + param
        );
        if (result?.message == "Success") {
          Message.success("Deactivated Successfully ");
          setIsLoading(false);
        } else {
          setIsLoading(false);

          Message.error(
            result?.message || "Something went wrong! Please try again later."
          );
        }
      } else {
        setIsLoading(true);
        setVisible((pre) => ({ show: false, type: "" }));
        let result = await ManageApis(
          "post",
          global.ActivateClientByUser + param
        );
        if (result?.message == "Success") {
          Message.success("Activated Successfully");
          setIsLoading(false);
        } else {
          setIsLoading(false);

          Message.error(
            result?.message || "Something went wrong! Please try again later."
          );
        }
      }
      //console.log(param);
    } catch (error) {
      //console.log(error);
    }
  };

  const handleAddAccounts = async () => {
    // ""
    setIsLoading(true)
    setVisible((pre) => ({ show: false, type: "" }));
    const rqstbdy = {
      userId: currentUserId,
      accounts: newAccount?.accountList
    }
    //console.log(rqstbdy)
    const result = await ManageApis("post", global.addNewAccounts, rqstbdy)
    if (result?.message == "Success") {
      Message.success("Account Added Successfully");
      setIsLoading(false);
      setNewAccount()
      setSelectedAccount([])
    } else {
      setIsLoading(false);
      setNewAccount()
      setSelectedAccount([])

      Message.error(
        result?.message || "Something went wrong! Please try again later."
      );
    }
  }

  const renderPopup = () => {
    switch (visible.type) {
      case "list_account":
        return (
          <>
            {/* <div className="row align-items-center">
              <div className="col-12 pt-1 pt-sm-0 mb-3 mb-sm-0">
                <div className=" pt-2">
                  {userAccountListData.length ? <ul className="list-unstyled">

                    {userAccountListData.map((itm) => (
                      // //console.log("------------------------->", itm),
                      <li className="border-bottom" >
                        {Object.values(itm)}
                      </li>
                    ))}
                  </ul> : <div className="d-flex flex-column align-items-center mt-0 mt-md-5">
                    <img
                      src={nodata}
                      className="no_data_thumbnail object_fit_contain"
                    />
                    <h4 className="text_gray7 font_16 mt-3">
                      {" "}
                      No Data To Preview
                    </h4>
                  </div>}
                </div>
              </div>
            </div> */}
            <DataTable
              columnData={accountsColumn}
              rowData={userAccountListData}

            // total={userAccountListData?.length}
            // onChangeTable={onChangeTable}
            />
          </>
        );
        break;
      case "createuser":
        return (
          <div className="row align-items-center">
          <div className="col-12 text_m1 fw_500 d-none">Menu</div>
          <div className="col-12 pt-1 pt-sm-0 mb-3 mb-sm-0">
            <div className="pt-2">
              <div className="data w-100 d-grid gap-2">
                {newUserCreateForm.map((itm, index) => (
                  <div key={index}>
                    {itm.type === "select" ? (
                      <div className="form_bx_stack mb-1">
                        <label className="mb-0 text_m1 text-black font_15">
                          {itm.label}
                        </label>
                       {itm.required == true ?  <span className="text-danger">*</span> : ''}
                        <div className="data w-100 mt-1 input_withicon end">
                        <select
                          className="form-control pe-0"
                          name={itm.name}
                          value={createUserData[itm.name]} // This should be the ID
                          onChange={(e) => handleChange(e, itm.regex)}
                        >
                          <option value="">Select ...</option>
                          {itm.options.map((option) => (
                            <option key={option.key} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                          <i className="fas fa-angle-down icn p-2 text_gray "></i>
                        </div>
                        {errors[itm.name] && (
                          <span className="font_12 ps-1 text-danger text-capitalize">
                            {errors[itm.name]}
                          </span>
                        )}
                      </div>
                    ) : itm.type === 'multiselect' ? (
                      <>
                        <label className="mb-0 text_m1 text-black font_15">
                          {itm.label}
                        </label>
                        {itm.required == true ?  <span className="text-danger">*</span> : ''}
                        <div className="multi-custom-style">
                          <MultiSelect
                            options={itm.options}
                            value={itm.selected}
                            onChange={(selectedOptions) =>
                              handleMultiselect(selectedOptions, itm.name)
                            }
                            className="text-black"
                            labelledBy="Select"
                          />
                          {errors[itm.name] && (
                            <span className="font_12 ps-1 text-danger">
                              {errors[itm.name]}
                            </span>
                          )}
                        </div>
                      </>
                    ) : (
                      <InputComponent2
                        label={itm.label}
                        name={itm.name}
                        type={itm.type}
                        onchange={(e) => handleChange(e, itm.regex)}
                        value={createUserData[itm.name] || ""}
                        error={errors[itm.name]}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-4 d-flex justify-content-end">
              <button
                className="btn btn-master px-3 font_14"
                onClick={handleCreateUserSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
        
        );
        break;
      case "Add_Account":
        return (
          <>
            <div className="multi-custom-style">

              <MultiSelect
                options={option}
                value={selectedAccount}
                onChange={handleMultiselect}

                className="text-black"
                labelledBy="Select"

              />
              {true && (
                <span className="font_12 ps-1 text-danger">
                  {errors.mappingUserClientRequest}
                </span>
              )}
            </div>
            <div className="mt-4 d-flex justify-content-end gap-1">
              <button
                className="btn btn-master px-3 font_14 "
                onClick={() => setVisible(() => ({ type: "list_account", show: true }))}
              >
                Back
              </button>
              <button
                className="btn btn-master px-3 font_14 "
                onClick={handleAddAccounts}
              >
                Submit
              </button>
            </div >
          </>
        );
        break
      default:
        break;
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <AlertBox
        show={showAlert.show}
        message={showAlert.message}
        enableFailIcon={showAlert.isfalse}
        enableSuccessIcon={showAlert.isSuccess}
        handlecancel={handleAlertBoxCancel}
      />
      <div className="p-2">
        <section className="admin_Section ">
          <div
            className={`d-flex justify-content-between align-items-center ${data?.length > 0 ? "" : "d-none"
              }`}
          >
            <h3 className="text_master2 mb-0 text-uppercase  py-2 font_18 fw_600">
              Client Admin List
            </h3>
            <div className="  flex-column flex-md-row g-1 d-flex gap-1 justify-content-between ">
              <div className=" arco_inputsearch ">
                <InputSearch
                  value={searchText}
                  onChange={handlesearch}
                  allowClear
                  placeholder="Enter username "
                />
              </div>
              <button
                className="btn btn-master font_14 px-4"
                onClick={() =>
                  setVisible(() => ({
                    show: true,
                    type: "createuser",
                  }))
                }
              >
                Add New User +
              </button>
            </div>
          </div>
          <div className="table_type02 pb-5 mt-3 table-responsive custom_scroll1 h-100">
            {!data?.length > 0 ? (
              <div className="d-flex  h-100">
                <div className="m-auto text-center">
                  <i className="fas fa-user-alt-slash font_18 mb-2"></i>
                  <div className="pb-2">Currently No User Available</div>
                  <button
                    className="btn btn-master font_14 px-4"
                    onClick={() =>
                      setVisible(() => ({
                        show: true,
                        type: "createuser",
                      }))
                    }
                  >
                    Add New User +
                  </button>
                </div>
              </div>
            ) : (
              // <TableComponent
              //   onclickView={onclickView}
              //   tableHeader={["Name", "Email", ""]}
              //   ListingData={UserList}
              //   tableData={["fullName", "email"]}
              // />
              <DataTable
                columnData={columns}
                rowData={UserList}
                onChangeTable={onChangeTable}
                current={currentPage}
                pageSize={pageSize}
                total={data?.length}
                loading={tableLoader}
              />
            )}
          </div>
        </section>
      </div>

      <PopupModal
        title={`${visible.type == "list_account" ? "Accounts List" : visible.type == "Enter Details" ? "Enter Details" : "Add Account"
          }`}
        size="lg"
        visible={visible.show}
        backdrop={"static"}
        onClick={() => setVisible(() => ({ type: "Add_Account", show: true }))}
        handleClose={() => {
          setVisible((pre) => ({ type: "", show: false }));
          setCreateUserData(userCreateinitialValue);
          setSelected([])
          setErrors({})

        }}
      >
        {renderPopup()}
      </PopupModal>
    </>
  );
}

export default ClientAdminList;
